import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useRecordEvent} from "aws-rum-react";
import MatchingManualsTable from "./MatchingManualsTable";
import {IImageManualModel} from "../../types/manualFinder";
import {FeedbackButtons, PaginationControls} from "../../components";
import EmptyState from "../../components/EmptyState/EmptyState";

interface IMatchingManualsImageProps {
    manualsBasedOnImages: IImageManualModel[];
    setIsLoading: (loading: boolean) => void;
}

export const ManualFinderAutomaticSelection: React.FC<IMatchingManualsImageProps> = ({
                                                                                   manualsBasedOnImages,
                                                                                   setIsLoading
                                                                               }) => {
    const {t} = useTranslation();
    const recordEvent = useRecordEvent();
    const [isManualFeedbackProvided, setIsManualFeedbackProvided] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    useEffect(() => {
        setIsManualFeedbackProvided(false);
    }, [manualsBasedOnImages]);

    const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber);
    const handleItemsPerPageChange = (value: string | null) => {
        if (value) {
            setItemsPerPage(Number(value));
            setCurrentPage(1);
        }
    };

    const handleClickFeedbackButtons = (isFound: boolean) => {
        recordEvent("AutoManualSearchFeedbackButtonClicked", {
            status: isFound ? "Manual Found" : "Manual not found",
            foundManuals: manualsBasedOnImages,
        });
        setIsManualFeedbackProvided(true);
        toast(t("ExtractedImages.FeedbackSubmitted"), {type: "success"});
    };

    if (manualsBasedOnImages.length === 0) {
        return <EmptyState message={t("Filter.resultsNotFound")}/>;
    }

    const paginatedManuals = manualsBasedOnImages.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="d-flex flex-column gap-3 p-lg-3">
            <FeedbackButtons
                handleClickFeedbackButtons={handleClickFeedbackButtons}
                isManualFeedbackProvided={isManualFeedbackProvided}
                t={t}
            />
            <MatchingManualsTable manuals={paginatedManuals} setIsLoading={setIsLoading}/>
            <PaginationControls
                totalPages={Math.ceil(manualsBasedOnImages.length / itemsPerPage)}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                itemsPerPage={itemsPerPage}
                handleItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>
    );
};
